module.exports = __webpack_public_path__ + "1641d4feddbd6a8bd2cfbfa8b9afd329.usdz";